import { AxiosResponse } from "axios";
import { Module } from "vuex";
import {
    SET_ERRORMSG,
    SET_SUBSCRIPTION,
    SET_SUBSCRIPTIONS,
    SET_SUBSCRIPTION_PLANS,
} from "../mutation_types";
import {
    CLEAR_SUBSCRIPTIONS_ISLOADING,
    GET_SUBSCRIPTIONS,
    GET_SUBSCRIPTION_PLANS,
    INITIALIZE_SUBSCRIPTION,
    VERIFY_SUBSCRIPTION_PAYMENT,
} from "../action_types";
import { StateObject } from "@/dtos/state.dto";
import SubscriptionService from "@/services/subscription";
import {
    GetSubscriptionPlans,
    GetSubscriptions,
    InitializeSubscription,
} from "@/dtos/subscription.dto";

const subscription: Module<any, {}> = {
    state: {
        subscription: { data: null, isLoading: false },
        subscriptions: { data: null, metaData: null, isLoading: false },
        subscriptionPlans: { data: null, metaData: null, isLoading: false },
    },
    getters: {
        subscription: (state) => state.subscription,
        subscriptions: (state) => state.subscriptions,
        subscriptionPlans: (state) => state.subscriptionPlans,
    },
    mutations: {
        [SET_SUBSCRIPTION]: (state: { subscription: StateObject }, payload: any) => {
            if (payload.data !== undefined) state.subscription.data = payload.data;
            state.subscription.isLoading = payload.isLoading;
        },
        [SET_SUBSCRIPTIONS]: (state: { subscriptions: StateObject }, payload: any) => {
            if (payload.data !== undefined) state.subscriptions.data = payload.data;
            if (payload.metaData !== undefined) state.subscriptions.metaData = payload.metaData;
            state.subscriptions.isLoading = payload.isLoading;
        },
        [SET_SUBSCRIPTION_PLANS]: (state: { subscriptionPlans: StateObject }, payload: any) => {
            if (payload.data !== undefined) state.subscriptionPlans.data = payload.data;
            if (payload.metaData !== undefined) state.subscriptionPlans.metaData = payload.metaData;
            state.subscriptionPlans.isLoading = payload.isLoading;
        },
    },
    actions: {
        [GET_SUBSCRIPTIONS]: async ({ commit }, payload: GetSubscriptions) => {
            commit(SET_SUBSCRIPTIONS, { data: null, isLoading: true });
            const result: AxiosResponse = await SubscriptionService.getSubscriptions(
                payload ?? {},
            );
            if (result?.data?.status) {
                commit(SET_SUBSCRIPTIONS, {
                    data: result.data.data,
                    metaData: result.data.metaData,
                    isLoading: false,
                });
                return true;
            }
            commit(SET_SUBSCRIPTIONS, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [GET_SUBSCRIPTION_PLANS]: async ({ commit }, payload: GetSubscriptionPlans) => {
            commit(SET_SUBSCRIPTION_PLANS, { data: null, isLoading: true });
            const result: AxiosResponse = await SubscriptionService.getSubscriptionPlans(
                payload ?? {},
            );
            if (result?.data?.status) {
                commit(SET_SUBSCRIPTION_PLANS, {
                    data: result.data.data,
                    metaData: result.data.metaData,
                    isLoading: false,
                });
                return true;
            }
            commit(SET_SUBSCRIPTION_PLANS, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        // Returns the { checkoutUrl, txRef, paymentId } payload on success so the
        // page can redirect the browser to Chapa; false on failure.
        [INITIALIZE_SUBSCRIPTION]: async ({ commit }, payload: InitializeSubscription) => {
            commit(SET_SUBSCRIPTION, { data: null, isLoading: true });
            const result: AxiosResponse = await SubscriptionService.initialize(payload);
            if (result?.data?.status) {
                commit(SET_SUBSCRIPTION, { data: result.data.data, isLoading: false });
                return result.data.data;
            }
            commit(SET_SUBSCRIPTION, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        // Returns the verification payload ({ isPaid, status, ... }) or false.
        // `payload` is the Chapa tx_ref string or an { txRef|paymentId|subscriptionId } object.
        [VERIFY_SUBSCRIPTION_PAYMENT]: async ({ commit }, payload: string | { txRef?: string; paymentId?: string; subscriptionId?: string }) => {
            commit(SET_SUBSCRIPTION, { isLoading: true });
            const result: AxiosResponse = await SubscriptionService.verifyPayment(payload);
            if (result?.data?.status) {
                commit(SET_SUBSCRIPTION, { data: result.data.data, isLoading: false });
                return result.data.data;
            }
            commit(SET_SUBSCRIPTION, { isLoading: false });
            if (result) commit(SET_ERRORMSG, result.data.msg);
            return false;
        },
        [CLEAR_SUBSCRIPTIONS_ISLOADING]: ({ commit }) => {
            commit(SET_SUBSCRIPTION, { isLoading: false });
            commit(SET_SUBSCRIPTIONS, { isLoading: false });
            commit(SET_SUBSCRIPTION_PLANS, { isLoading: false });
        },
    },
};

export default subscription;
